import React from "react";
import environment from "../../../environment";
import { graphql } from "babel-plugin-relay/macro";
import { QueryRenderer } from "react-relay";
import { OperationType } from "relay-runtime";
import BlendSummary from "./BlendSummary";
import { Customer, Distributor } from "../Customers/CustomerParentComponent";
import Blendlogs from "./BlendLogs";
import BlendLogsDownload from "./BlendLogsDownload";
import { GetLocationListType } from "../../models/_location";
import { GetMachinesNameAndSerialsMachineType, GetMachineStatusListType } from "../../models/_machine";
import { GetRegionListType } from "../../models/_region";
import { GetLocationTypeListType } from "../../models/_locationType";
import { GetMarketSegmentListType } from "../../models/_marketSegment";
import { Flavor } from "../../models/_flavor";

interface BlendParentComponentQueryResponse {
  getCustomerList: Customer[];
  getLocationList: GetLocationListType[];
  getRegions: GetRegionListType[];
  getMachineStatus: GetMachineStatusListType[];
  getLocationTypes: GetLocationTypeListType[];
  getMarketSegment: GetMarketSegmentListType[];
  getDistributors: Distributor[];
  getMachineList: GetMachinesNameAndSerialsMachineType[];
  getFlavors: Flavor[]
}

export interface BlendSummaryProps {
  customers: Customer[];
  locations: GetLocationListType[];
  distributors: Distributor[];
  locationTypes: GetLocationTypeListType[];
  machineStatus: GetMachineStatusListType[];
  machines: GetMachinesNameAndSerialsMachineType[];
  marketSegments: GetMarketSegmentListType[];
  regions: GetRegionListType[];
}

type BlendParentComponentQuery = OperationType & {
  response: BlendParentComponentQueryResponse;
  variables: Record<string, never>;
};

class BlendParentComponent extends React.Component <any, any>  {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: {} | Readonly<{}>) {
    super(props); 
  }
  render() {
    return (
      <QueryRenderer<BlendParentComponentQuery>
        environment={environment}
        query={graphql`
          query BlendParentComponentQuery {
            getRegions {
              id
              name
            }
            getLocationList {
              id
              uuid
              name
               servicePlan{
                id
                indicater
              }
            }
            getMachineStatus {
              id
              name
              description
            }
            getLocationTypes {
              id
              name
              description
              isDefault
            }
            getCustomerList {
              id
              name
            }
            getMarketSegment {
              id
              name
            }
            getDistributors {
              id
              name
            }
            getMachineList {
              id
              uuid
              serialNumber
              name
              locationId
              location {
                name
              }
            }
            getFlavors {
              id
              name
              flavor
            }
          }
        `}
        variables={{}}
        render={({ error, props }) => {
          if (error) {
            return <div>Error loading blend summary data: {error.message}</div>;
          }

          if (!props) {
            return <div className="loading-indicator">Loading...</div>;
          }
          const {
            getCustomerList,
            getLocationList,
            getDistributors,
            getLocationTypes,
            getMachineStatus,
            getMachineList,
            getMarketSegment,
            getRegions,
            getFlavors
          } = props;

          const {componentName} = this.props;

          if(componentName === "blendSummary") {
            return (
              <BlendSummary
                customers={getCustomerList}
                locations={getLocationList}
                distributors={getDistributors}
                locationTypes={getLocationTypes}
                machineStatus={getMachineStatus}
                machines={getMachineList}
                marketSegments={getMarketSegment}
                regions={getRegions}
              />
            );
          }

          if(componentName === "blendLogs") {
            return (
              <Blendlogs
                customers={getCustomerList}
                locations={getLocationList}
                machines={getMachineList}
                flavors={getFlavors}
              />
            );
          }

          if(componentName === "blendLogDownload") {
            return (
              <BlendLogsDownload
                customers={getCustomerList}
                locations={getLocationList}
                machines={getMachineList}
              />
            );
          }
          
        }}
      />
    );
  }
}

export default BlendParentComponent;
